import { Injectable } from '@angular/core';

declare const DataMappingInterface: any;
declare const ddo: any;

@Injectable()
export class AdobeAnalyticsService {
    private _isAdobeAnalyticsAvailable = false;
    public deviceType = '';

    constructor() {
        console.log('constructing AdobeAnalyticsWrapper');

        if (typeof (DataMappingInterface) !== 'undefined') {
            this._isAdobeAnalyticsAvailable = true;
        } else {
            console.error('newadobe is not available');
        }
    }

    public CDLData = {
        'page.pageInfo.language': 'EN',
        'page.pageInfo.viewedUIExperience': this.getDeviceWidth,
        'page.pageInfo.appCode': 'fNet',
        'page.pageInfo.lineOfBusiness': 'Wireline',
        'page.pageInfo.responsiveWebDesignFlag': '1',
        'user.attributes.companyID': '21',
        'user.attributes.ABSenterpriseTypeDetail': 'Government',
        'user.attributes.marketSegment': 'GOVERNMENT',
        'user.login.loginSource': 'passthru',
        'user.account.serviceType': 'Legacy',
        'user.account.accountInFocusType': 'Telco',
        'user.actorType': 'Customer',
        'page.category.applicationName': 'FirstNet ICAM',
        'page.category.pageFunction': 'Service',
        'page.category.pageOwnership': 'Business'
    };

    getDeviceWidth() {
        const deviceWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        console.log(`deviceWidth: ${deviceWidth}`);
        this.deviceType = 'Desktop';
        if (deviceWidth <= 480) {
            this.deviceType = 'Smartphone';
        }
        if (deviceWidth > 480 && deviceWidth <= 1024) {
            this.deviceType = 'Tablet';
        }
        console.log(`deviceWidth: ${deviceWidth}`);
        return deviceWidth;
    }

    sendPageLoadParams(specificPageLoadData) {
        const eventCode = 'Page_Load';
        // Add page specific data from the requirements to additional data
        // Add merged data to page specific data
        const combinedData = this.CDLData ? { ...this.CDLData, ...specificPageLoadData } : specificPageLoadData;
        // adding our data to appanalytics send it within the icam-app.js file on load of the page
        this.pushToDataLayerInit('pageLoad', eventCode, combinedData);
    }

    pushToDataLayerInit(eventAction, eventCode, objData) {
        if (typeof DataMappingInterface !== 'undefined') {
            DataMappingInterface.init({
                'eventAction': eventAction,
                'eventCode': eventCode,
                'additionaldata': objData,
                'eddsupported': false,
                'datatransform': false

            });
        }
    }

    sendCDLEvent(eventData, cdlEventData) {
        const additionaldata = {
            'successFlag': eventData.successflag,
            'statusMessage': eventData.statusmessage,
            'errorType': eventData.errortype,
            'linkName': eventData.linkname,
            'linkPosition': eventData.linkPosition,
            'slotFriendlyName': 'Body',
            'linkDestinationUrl': eventData.desturl,
            'eventCode': eventData.eventCode
        };
        const additionaldata1 = cdlEventData ? { ...cdlEventData, ...additionaldata } : additionaldata;
        this.pushToDatalayerPushEvent(eventData.eventAction, eventData.eventCode, additionaldata1);
    }

    pushToDatalayerPushEvent(eventAction, eventCode, objData) {
        if (typeof ddo !== 'undefined') {
            ddo.pushEvent(eventAction, eventCode, objData);
        }
    }

    cdlModalLoad(pageFriendlyName, pageLocationUrl) {
        const origPageFriendlyName = this.CDLData['page.pageInfo.friendlyPageName'];
        const origpageLocationUrl = this.CDLData['page.location.url'];
        const eventCode = 'Page_Load';
        this.CDLData['page.location.url'] = pageLocationUrl;
        this.CDLData['page.pageInfo.friendlyPageName'] = pageFriendlyName;
        this.pushToDataLayerInit('pageLoad', eventCode, this.CDLData);
        // Set the original values from the page level back after calling a modal push
        this.CDLData['page.pageInfo.friendlyPageName'] = origPageFriendlyName;
        this.CDLData['page.location.url'] = origpageLocationUrl;
    }

}
